import { render, staticRenderFns } from "./newoutlineshow.vue?vue&type=template&id=c95ccb10&scoped=true&"
import script from "./newoutlineshow.vue?vue&type=script&lang=js&"
export * from "./newoutlineshow.vue?vue&type=script&lang=js&"
import style0 from "./newoutlineshow.vue?vue&type=style&index=0&id=c95ccb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95ccb10",
  null
  
)

export default component.exports